export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'LO-LAO',
        name: 'Lao SengKeo',
        normal: '@ຢຟໂຖຸູຄຕຈຂຊໍ\\ົໄຳພະິີຣນຍບລັຫກດເ້່າສວງຜປແອຶືທມໃຝ',
        shift: { 0: '©໑໒໓໔໌ຼ໕໖໗໘໙ໍ່ໝົ້໐້ຳ-+ິ້ີ້ຮ່ຳຽ-/ັ້;.,:໊໋!?%', 37: '&(ຯໜຶ້ື້ໆ"$)' }
    })
}
